


















import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import {  SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import TermsCondition from './terms-condition.vue';
import { InfoState } from '@/core';

// import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';

const cssPrefix = 'download-list';

@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
    SwToggle,
    SwButton,
    SwSelect,
    TermsCondition,
  },
  directives: {
    tooltip,
  },
})

export default class DownloadList extends SwExtendedVue {
  cssPrefix = cssPrefix;
  tcConditions : string = '';
  showTNCDialogFlag : boolean = false;
  currentSoftwareData : any ;
  @Prop() softwareList:any;
  @Prop() isApplicable:any;
  @Prop() isActiveFirmware:boolean;
  downloadClicked(item : any, releaseNote : boolean) {
    if (releaseNote) {
      window.open(item.releaseNoteURL, '_blank');
    } else if (this.isApplicable) {
      if (item.TNCID && item.TNCID.toString() !== '0') {
        this.callTcApi(item);
      } else {
        // tslint:disable-next-line:max-line-length
        const payload = { username:this.$store.getters.getUserId, swID:item.softwareID, swGrpID: item.softwareGroupID, isRNotes: item.isRNotes, appName:'MSW', oemCode:'SNWL' };
        this.$store.dispatch(
          'DownloadCenterStoreModule/downloadSoftware', payload,
        )
        .then((resp: any) => {
          if (resp.operationStatus === 'NOK') {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          } else {
            window.open(resp.content.downloadUrl);
          }
        })
        .catch((errorRes: any) => {
          console.error(errorRes.message);
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
      }
    } else {
      window.open(item.releaseNoteURL, '_blank');
    }
    this.$emit('downloadClick', item);
  }
  created() {
    console.warn(this.softwareList);
    console.warn(this.isApplicable);
  }
  getVisibility(items : any) {
    return  items.hasOwnProperty('releaseNoteURL') ? items.releaseNoteURL ? items.releaseNoteURL.length > 0 ? true : false :false : false;
  }
  callTcApi(items : any) {
    const request = {
      userName: this.$store.getters.getUserId,
      swId: items.softwareID || 0,
      tncId: items.TNCID || 0,
      oemCode: 'SNWL',
    };
    this.$store
    .dispatch('MswProductsStoreModule/getTermsAndConditions', request)
    .then((res: any) => {
      if (res.operationStatus === 'OK') {
        this.currentSoftwareData = items;
        console.warn(res);
        this.tcConditions =  res.content?.termsNConditions?.replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&gt;/g, '/>');
        this.showTNCDialogFlag = true;
        this.$store.commit('stopLoading');
      } else {
        const message: InfoState = { infoType: 'failed', infoMsg: res.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    });
    console.warn(items);
  }
  closeDialog() {
    this.showTNCDialogFlag = false;
  }
  downloadFile() {
    console.warn('download file');
  }
  acceptCondition() {
    this.closeDialog();
    const payload = { username:'ANONYMOUS', swID:this.currentSoftwareData?.softwareID, swGrpID: this.currentSoftwareData?.softwareGroupID, isRNotes: this.currentSoftwareData?.isRNotes, appName:'MSW', oemCode:'SNWL' };
    if (this.currentSoftwareData?.free) {
      // tslint:disable-next-line:max-line-length
      payload.username = 'ANONYMOUS';

    } else {
      // tslint:disable-next-line:max-line-length
      payload.username = this.$store.getters.getUserId;
    }
    this.$store.dispatch(
      'DownloadCenterStoreModule/downloadSoftware', payload,
    )
    .then((resp: any) => {
      if (resp.operationStatus === 'NOK') {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      } else {
        window.open(resp.content.downloadUrl);
      }
    })
    .catch((errorRes: any) => {
      console.error(errorRes.message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }
}
